import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {useLocalImage} from '@app/hooks/use-local-image';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

const IMAGE_CONFIG: LocalImageConfig = {
	default: '2f7f18c71ab03a692cb9911ed85b2960.png',
	fr: '6fbdfc9eedf293ca57dba5b22b18bb00.png',
};

export const MusicQuizSection: FunctionComponent = () => {
	const {t} = useTranslation();
	const src = useLocalImage(IMAGE_CONFIG);
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'musicquizlandingpage_title_Xfeaturenamehaslanded_standalone-web',
							{ns: 'musicquiz'},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'musicquizlandingpage_text_testyourskillsandchallengefriends_standalone-web',
							{
								ns: 'musicquiz',
							},
						)}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					aspectRatio="1440/420"
					objectFit={{base: 'cover', sm: 'contain'}}
					quality={90}
					src={src}
					alt={t(
						'musicquizlandingpage_title_Xfeaturenamehaslanded_standalone-web',
						{ns: 'musicquiz'},
					)}
				/>
			}
			cta={
				<LandingButtonLink
					tracking={{eventaction: 'discover', eventlabel: 'music-quiz'}}
					href="/features/music-quiz"
				>
					{t('generic_action_discoverallgames_standalone-web', {ns: 'common'})}
				</LandingButtonLink>
			}
		/>
	);
};
